export default __webpack_public_path__ + "static/media/react.9e9c78fa.svg";